import { useMemo } from 'react';
import { DEFAULT_AI_OPERATION_COSTS } from 'constants/aiCredits';
import { useTenantInfo } from 'hooks/useTenantInfo';

export const useAIOperationCosts = () => {
  const { aiOperationCosts } = useTenantInfo();

  return useMemo(() => {
    const costs = aiOperationCosts || DEFAULT_AI_OPERATION_COSTS;

    return {
      jobCompetenciesCost: costs.extract_job_competencies,
      jobDescriptionCost: costs.generate_job_description,
      cultureProfileCost: costs.extract_culture_competencies
    };
  }, [aiOperationCosts]);
};
